import { useTranslate } from 'react-admin';

const UnassignedField = ({ sx, label }) => {
    const translate = useTranslate();
    const fieldLabel = label || translate('common.unassigned');

    return (
        <span className='unassigned-field gray-text' style={sx}>
            {fieldLabel}
        </span>
    );
};

export default UnassignedField;
